/**
 * Filter types configuration for reusable filter components
 */
export const FILTER_TYPES = {
  TEXT: {
    type: "text",
    operators: [
      { value: "is", label: "Is" },
      { value: "is_not", label: "Is not" },
      { value: "contains", label: "Contains" },
      { value: "not_contains", label: "Does not contain" },
    ],
    component: "v-text-field",
  },
  SELECT: {
    type: "select",
    operators: [
      { value: "is", label: "Is" },
      { value: "is_not", label: "Is not" },
    ],
    component: "v-select",
  },
  NUMBER: {
    type: "number",
    operators: [
      { value: "equals", label: "Equals" },
      { value: "not_equals", label: "Not equal" },
      { value: "greater", label: "Greater than" },
      { value: "greater_equal", label: "Greater than or equal to" },
      { value: "less", label: "Less than" },
      { value: "less_equal", label: "Less than or equal to" },
      { value: "between", label: "Between" },
      { value: "not_between", label: "Not between" },
    ],
    component: "v-text-field",
    props: { type: "number" },
  },
  BOOLEAN: {
    type: "boolean",
    operators: [{ value: "is", label: "Is" }],
    component: "v-select",
    options: [
      { value: true, label: "True" },
      { value: false, label: "False" },
    ],
  },
};
